/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ApiConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the EmailTranslation HTTP resource (factory product). */
export class EmailTranslationResource {
}

/** Angular DI token for the EmailTranslationTest HTTP resource (factory product). */
export class EmailTranslationTestResource {
}

export function createEmailTranslationResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  return createAdnHttpResource(send, 'emailtranslations', () => localUserProfile, 'emailTranslation', {showEditableOnly: true});
}

export function createEmailTranslationTestResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);

  return {
    test: function(id: any, emailAddress: any): Promise<any> {
      const uri = ApiConfig.obtain().getVersionedUri(['emailtranslations', 'sendtest', id]);
      return send({method: 'GET', url: uri, params: {to: emailAddress}});
    }
  };
}

export const emailTranslationResourceProvider = {
  provide: EmailTranslationResource,
  useFactory: createEmailTranslationResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

export const emailTranslationTestResourceProvider = {
  provide: EmailTranslationTestResource,
  useFactory: createEmailTranslationTestResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService]
};

